// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__9W1ag","header__img":"styles_header__img__r2kFD","header__body":"styles_header__body__z93Vq"};